import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="contacts" className="border-t border-white/5 bg-[#111418]">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 md:py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-leaf-line text-yellow-400 text-xl"></i>
            </div>
            <span className="text-white font-bold">WheatVest</span>
            <span className="text-white/30 text-sm">{t('footer_tagline')}</span>
          </div>
          <div className="flex flex-wrap gap-4 md:gap-5 items-center">
            {(['about', 'packages', 'calculator'] as const).map((item) => (
              <button key={item} onClick={() => scrollTo(item)}
                className="text-white/40 hover:text-white/70 text-xs transition-colors cursor-pointer">
                {t(`nav_${item}`)}
              </button>
            ))}
          </div>
          <div className="text-white/25 text-xs text-center sm:text-right">{t('footer_copy')}</div>
        </div>
      </div>
    </footer>
  );
}
